<template>
  <a-modal
    ref="createModal"
    title="创建采购需求"
    :width="950"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
  >
    <ls-info-form :split-number="4">
      <ls-info-item title="计划单号" slot="planNo" IsContentTip :value="billData.planNo" />
      <ls-info-item title="计划单行ID" slot="planLineId" IsContentTip :value="billData.planLineId" />
      <ls-info-item title="物料编码" slot="itemCode" IsContentTip :value="billData.itemCode" />
      <ls-info-item title="物料名称" slot="itemName" IsContentTip :value="billData.itemName" />
      <ls-info-item title="计划周期" slot="planCycle" IsContentTip :value="billData.planCycle" />
      <ls-info-item title="计划数量" slot="planQuantity" IsContentTip :value="billData.planQuantity" />
      <ls-info-item title="采购空闲数" slot="purchaseFreeQuantity" IsContentTip :value="billData.purchaseFreeQuantity" />
      <ls-info-item title="供应商" slot="supplierName" IsContentTip :value="billData.supplierName" />
    </ls-info-form>
    <a-form-model ref="listFormRef" :model="listForm" class="table-form">
      <lsMetable
        class="editMaterial"
        :columns="columns"
        :data-list="listForm.dataList"
        :scroll="{y:300}"
        :IsEdit="false"
        @addDataList="addDataList"
      >
        <template #planDeliveryDate="{ record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.planDeliveryDate'" :rules="rules">
            <a-date-picker v-model="record.planDeliveryDate" valueFormat="YYYY-MM-DD" />
          </a-form-model-item>
        </template>
        <template #purchaseQuantity="{ record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.purchaseQuantity'" :rules="positiveNumRule">
            <a-input-number v-model="record.purchaseQuantity" :precision="3" :min="0.001" :max="billData.purchaseFreeQuantity" />
          </a-form-model-item>
        </template>
        <template #purchaseGroup="{ record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.purchaseGroup'" :rules="rules">
            <global-select
              v-model="record.purchaseGroup"
              selectType="selectSearch"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/likeList"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'SCP_PROJECT_TEAM' }"
              searchParam="lookupValue"
            />
          </a-form-model-item>
        </template>
        <template #purchaseUser="{ record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.purchaseUser'" :rules="rules">
            <global-select
              v-model="record.purchaseUser"
              selectType="selectSearch"
              requestApi="/mes/mesDiscreteJobs/founderBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="jobCode"
            />
          </a-form-model-item>
        </template>
        <template #remark="{ record, index }">
          <a-form-model-item :prop="'dataList.' + index + '.remark'" :rules="rules">
            <a-input v-model="record.remark" :maxLength="50" />
          </a-form-model-item>
        </template>
        <template #operation="{ record, index }">
          <ls-cancel @confirm="onDelete(record,index)" title="确定要删除吗?">
            <a-icon type="delete" title="删除"/>
          </ls-cancel>
        </template>
      </lsMetable>
    </a-form-model>
    <a-space slot="footer">
      <a-button @click="onClose">取消</a-button>
      <a-button @click="onConfirmAdd" :loading="confirmLoading" type="primary">确认</a-button>
    </a-space>
  </a-modal>
</template>

<script>
import { apiCreatePurchaseDemand } from '@/api/scp/month-plan-pool/month-plan-pool'
import { positiveNumValidate } from '@/views/mes/workOrderManage/ticketsManageCc/common'
export default {
  name: 'RequirementModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      confirmLoading: false,
      visible: false,
      // 表单参数
      billData: {},
      listForm: {
        dataList: []
      },
      purchaseGroupList: [],
      // 表单校验
      rules: [
        { required: true, message: ' ', trigger: 'change' }
      ],
      positiveNumRule: [ { validator: positiveNumValidate } ],
      columns: [
        { dataIndex: 'index', title: '序号', width: 50, customRender: (text, record, index) => index + 1 },
        { dataIndex: 'purchaseQuantity', title: '采购数量', scopedSlots: { customRender: 'purchaseQuantity' }, width: 150 },
        { dataIndex: 'planDeliveryDate', title: '计划交货日期', width: 150, scopedSlots: { customRender: 'planDeliveryDate' } },
        { dataIndex: 'purchaseGroup', title: '采购组', width: 150, scopedSlots: { customRender: 'purchaseGroup' } },
        { dataIndex: 'purchaseUser', title: '采购员', scopedSlots: { customRender: 'purchaseUser' }, width: 150 },
        { dataIndex: 'remark', title: '备注', scopedSlots: { customRender: 'remark' }, width: 150 },
        { dataIndex: 'operation', title: '操作', scopedSlots: { customRender: 'operation' }, width: 90 }
      ]
    }
  },
  methods: {
    addDataList() {
      this.listForm.dataList.push(this.getInitRowData());
    },
    onDelete(record, index) {
      this.listForm.dataList.splice(index, 1);
    },
    onChangeMaterial(value, list, record) {
      const mItem = list.find(item => item.selectedValue === value);
      record.materialName = mItem?.bringOutDataTwo;
      record.materialUnit = mItem?.bringOutDataOne;
    },
    show (billData) {
      this.visible = true
      this.confirmLoading = false
      this.billData = billData
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.reset()
    },
    getParams() {
      let passIs;
      this.$refs.listFormRef.validate(valid => {
        passIs = valid;
      })
      if(this.listForm.dataList.length === 0) {
        this.$message.error('请填至少添加一行信息');
        return false;
      }
      if(passIs) {
        return {
          ...this.billData,
          lines: this.listForm.dataList
        }
      }
    },
    onConfirmAdd () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true;
      this.$emit('update:mainBtnLoading', true);
      // 所有采购数量是否大于计划数量
      apiCreatePurchaseDemand(params).then(response => {
        if (response.code === 200) {
          this.$message.success(response.data || '操作成功')
          this.$emit('successCall')
          this.reset()
          this.visible = false
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
        this.$emit('update:mainBtnLoading', false);
      })
    },
    // 表单重置
    reset () {
      this.listForm.dataList = [];
    },
    getInitRowData() {
      return {
        serialNo: this.listForm.dataList.length + 1,
        remark: '',
        purchaseGroup: undefined,
        planDeliveryDate: null,
        purchaseQuantity: null
      }
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
.table-form {
  /deep/ .ant-select {
    width: 100%;
  }

  input {
    width: 100%;
  }

  /deep/ .ant-input-number {
    width: 100%;
  }

  /deep/ .ant-calendar-picker {
    min-width: 100% !important;
  }

  /deep/ .ant-form-item-control {
    min-width: 100% !important;
  }
}
.title-text {
  font-size: 14px;
  font-weight: bolder;
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
</style>
